import React, { useEffect, useState } from "react";
import { Header, DefaultSideBar } from "components";
import TableReport from "components/TableReport";
import { report } from "services/report";

export default function ReportPage() {
	const [data, setData] = useState(null);

	const fetchData = async () => {
		try {
			const reportsData = await report();
			setData(reportsData.data);
		} catch (error) {
			console.error("Error fetching report data:", error);
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	return (
		<div className=" w-full relative bg-gray-100 pl-[81px] pt-[10vh]">
			<Header />
			<DefaultSideBar />
			{ data ? (
				<div className="flex flex-col items-start justify-start w-full mt-5 gap-[17px] px-10">
					<TableReport data={ data.reportings } />
				</div>
			) : (
				<div className="flex w-full h-[90vh] justify-center items-center">Loading...</div>
			) }
		</div>
	);
}
